import { useBreakpointValue } from "@chakra-ui/react";
import { MotionBox as Box } from "utils/motion";
import VideoPlayer from "components/sections/VideoPlayer";

const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { type: "tween", duration: 0.8, delay: 0.6 },
  },
};

export default function HeroStreamVideoSection({
  height,
  minHeight,
  maxHeight,
  videoSrc,
  mobileVideoSrc,
  mobileMetadata,
  bgOverlay,
  metadata,
  children,
}) {
  const isMobile = useBreakpointValue({ base: true, md: false }, { ssr: true });

  return (
    <Box
      width="100%"
      bg="black.900"
      as="section"
      style={{ overflow: "hidden" }}
      position="relative"
      height={["100vw", null, "100%"]}
    >
      <Box
        variants={fadeIn}
        initial="hidden"
        animate="visible"
        objectFit="cover"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        {isMobile === true ? (
          <Box key={mobileMetadata.video_id} minH="100vh">
            <VideoPlayer
              stream={{ type: "hls", data: mobileVideoSrc }}
              metadata={mobileMetadata}
              type="inline"
              fullBackground
              options={{
                autoplay: true,
                muted: true,
                controls: false,
                loop: true,
              }}
              style={{ aspectRatio: "1 / 1" }}
            />
          </Box>
        ) : isMobile === false ? (
          <Box key={metadata.video_id}>
            <VideoPlayer
              stream={{ type: "hls", data: videoSrc }}
              metadata={metadata}
              type="inline"
              fullBackground
              options={{
                autoplay: true,
                muted: true,
                controls: false,
                loop: true,
              }}
            />
          </Box>
        ) : null}
      </Box>
      <Box
        height={height || "100vh"}
        minHeight={minHeight || ["500px", "550px", "700px"]}
        maxHeight={maxHeight}
        position="relative"
        overflowX="hidden"
        overflowY="hidden"
        bg={bgOverlay}
      >
        {children}
      </Box>
    </Box>
  );
}
